import React from "react";
import styled, { css } from "styled-components";
import moment from "moment-timezone";

import { Text } from "src/library/components/Text";
import { Label } from "src/library/components/Forms";

import { DateInput } from "./DateInput";

export interface StartEndDateInputProps {
  title?: string;
  dateRange: DateRange;
  dateRangeUpdater: (type: "startDate" | "endDate", date: string) => void ;
}

export interface DateRange {
  start: string;
  end: string;
}

/**
 * Basic Start and End Date Range Picker. Does not hold local state, managed through props.
 */
const StartEndDateInput: React.ReactFCWithChildren<StartEndDateInputProps> = ({
  title, dateRange, dateRangeUpdater
}) => {
  return (
    <>
      {title && (
        <Text as="h4">
          {title}
        </Text>
      )}

      <InputsWrapper>
        <div className="input-wrapper">
          <Label
            for="start-date"
            label="Start Date"
          />

          <DateInput
            label="Start Date"
            date={moment.utc(dateRange.start).toDate()}
            setDate={date => dateRangeUpdater("startDate", moment.utc(date).format("YYYY-MM-DD"))}
            minimumDate={moment.utc().toDate()}
          />
        </div>

        <div className="input-wrapper end-date">
          <Label
            for="end-date"
            label="End Date"
          />

          <DateInput
            label="End Date"
            date={moment.utc(dateRange.end).toDate()}
            setDate={date => dateRangeUpdater("endDate", moment.utc(date).format("YYYY-MM-DD"))}
            minimumDate={moment.utc().toDate()}
            maximumDate={moment.utc().add(2, "years").toDate()}
          />
        </div>
      </InputsWrapper>
    </>
  );
};

const InputsWrapper = styled.div`
${({ theme }) => css`
  display: flex;

  .end-date {
    margin-left: ${theme.spacing.margins.xl};
  }

  .input-wrapper {
    display: flex;
    flex-direction: column;
  }
  `}
`;

export default StartEndDateInput;
